import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadLaboratoryConfidentialityDeedByLaboratoryId: ILaboratoryConfidentialityDeedLoadByLaboratoryIdActionCreator = (laboratoryId) => {
        return {
            type: ACTION_LABORATORYCONFIDENTIALITYDEED_LOAD_BY_LABORATORY_ID,
            laboratoryId
        }
    },
    LoadLaboratoryConfidentialityDeedById: ILaboratoryConfidentialityDeedLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_LABORATORYCONFIDENTIALITYDEED_LOAD_BY_ID,
            id
        }
    },
    LoadSuccess: ILaboratoryConfidentialityDeedLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_LABORATORYCONFIDENTIALITYDEED_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: ILaboratoryConfidentialityDeedLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_LABORATORYCONFIDENTIALITYDEED_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveLaboratoryConfidentialityDeed: ILaboratoryConfidentialityDeedSaveActionCreator = (formData) => {
        return {
            type: ACTION_LABORATORYCONFIDENTIALITYDEED_SAVE,
            formData
        }
    },
    SaveSuccess: ILaboratoryConfidentialityDeedSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_LABORATORYCONFIDENTIALITYDEED_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: ILaboratoryConfidentialityDeedSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_LABORATORYCONFIDENTIALITYDEED_SAVE_FAILURE,
            responseStatus
        }
    },

    ValidateLaboratoryConfidentialityDeed: ILaboratoryConfidentialityDeedValidateActionCreator = (formData) => {
        return {
            type: ACTION_LABORATORYCONFIDENTIALITYDEED_VALIDATE,
            formData
        }
    },
    ValidateSuccess: ILaboratoryConfidentialityDeedValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_LABORATORYCONFIDENTIALITYDEED_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: ILaboratoryConfidentialityDeedValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_LABORATORYCONFIDENTIALITYDEED_VALIDATE_FAILURE,
            responseStatus
        }
    },

    CreateLaboratoryConfidentialityDeed: ILaboratoryConfidentialityDeedCreateActionCreator = (laboratoryId) => {

        return {
            type: ACTION_LABORATORYCONFIDENTIALITYDEED_CREATE,
            laboratoryId
        }
    },
    CreateSuccess: ILaboratoryConfidentialityDeedCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_LABORATORYCONFIDENTIALITYDEED_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: ILaboratoryConfidentialityDeedCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_LABORATORYCONFIDENTIALITYDEED_CREATE_FAILURE,
            responseStatus
        }
    },

    DeleteLaboratoryConfidentialityDeed: ILaboratoryConfidentialityDeedDeleteActionCreator = (id) => {
        
        return {
            type: ACTION_LABORATORYCONFIDENTIALITYDEED_DELETE,
            id
        }
    },
    DeleteSuccess: ILaboratoryConfidentialityDeedDeleteSuccessActionCreator = () => {
        return {
            type: ACTION_LABORATORYCONFIDENTIALITYDEED_DELETE_SUCCESS,
        }
    },
    DeleteFailure: ILaboratoryConfidentialityDeedDeleteFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_LABORATORYCONFIDENTIALITYDEED_DELETE_FAILURE,
            responseStatus
        }
    },

    SyncLaboratoryConfidentialityDeed: ILaboratoryConfidentialityDeedSyncActionCreator = (laboratoryId) => {

        return {
            type: ACTION_LABORATORYCONFIDENTIALITYDEED_SYNC,
            laboratoryId
        }
    },
    SyncSuccess: ILaboratoryConfidentialityDeedSyncSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_LABORATORYCONFIDENTIALITYDEED_SYNC_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    SyncFailure: ILaboratoryConfidentialityDeedSyncFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_LABORATORYCONFIDENTIALITYDEED_SYNC_FAILURE,
            responseStatus
        }
    },

    Clear: ILaboratoryConfidentialityDeedClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_LABORATORYCONFIDENTIALITYDEED_CLEAR,
            propertiesToClear
        }
    },

    Filter: ILaboratoryConfidentialityDeedFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_LABORATORYCONFIDENTIALITYDEED_FILTER,
            formFilter
        }
    };



export const
    ACTION_LABORATORYCONFIDENTIALITYDEED_LOAD_BY_LABORATORY_ID = "ACTION_LABORATORYCONFIDENTIALITYDEED_LOAD_BY_LABORATORY_ID",
    ACTION_LABORATORYCONFIDENTIALITYDEED_LOAD_BY_ID = "ACTION_LABORATORYCONFIDENTIALITYDEED_LOAD_BY_ID",
    ACTION_LABORATORYCONFIDENTIALITYDEED_LOAD_SUCCESS = "ACTION_LABORATORYCONFIDENTIALITYDEED_LOAD_SUCCESS",
    ACTION_LABORATORYCONFIDENTIALITYDEED_LOAD_FAILURE = "ACTION_LABORATORYCONFIDENTIALITYDEED_LOAD_FAILURE",

    ACTION_LABORATORYCONFIDENTIALITYDEED_SAVE = "ACTION_LABORATORYCONFIDENTIALITYDEED_SAVE",
    ACTION_LABORATORYCONFIDENTIALITYDEED_SAVE_SUCCESS = "ACTION_LABORATORYCONFIDENTIALITYDEED_SAVE_SUCCESS",
    ACTION_LABORATORYCONFIDENTIALITYDEED_SAVE_FAILURE = "ACTION_LABORATORYCONFIDENTIALITYDEED_SAVE_FAILURE",

    ACTION_LABORATORYCONFIDENTIALITYDEED_VALIDATE = "ACTION_LABORATORYCONFIDENTIALITYDEED_VALIDATE",
    ACTION_LABORATORYCONFIDENTIALITYDEED_VALIDATE_SUCCESS = "ACTION_LABORATORYCONFIDENTIALITYDEED_VALIDATE_SUCCESS",
    ACTION_LABORATORYCONFIDENTIALITYDEED_VALIDATE_FAILURE = "ACTION_LABORATORYCONFIDENTIALITYDEED_VALIDATE_FAILURE",

    ACTION_LABORATORYCONFIDENTIALITYDEED_CREATE = "ACTION_LABORATORYCONFIDENTIALITYDEED_CREATE",
    ACTION_LABORATORYCONFIDENTIALITYDEED_CREATE_SUCCESS = "ACTION_LABORATORYCONFIDENTIALITYDEED_CREATE_SUCCESS",
    ACTION_LABORATORYCONFIDENTIALITYDEED_CREATE_FAILURE = "ACTION_LABORATORYCONFIDENTIALITYDEED_CREATE_FAILURE",

    ACTION_LABORATORYCONFIDENTIALITYDEED_DELETE = "ACTION_LABORATORYCONFIDENTIALITYDEED_DELETE",
    ACTION_LABORATORYCONFIDENTIALITYDEED_DELETE_SUCCESS = "ACTION_LABORATORYCONFIDENTIALITYDEED_DELETE_SUCCESS",
    ACTION_LABORATORYCONFIDENTIALITYDEED_DELETE_FAILURE = "ACTION_LABORATORYCONFIDENTIALITYDEED_DELETE_FAILURE",

    ACTION_LABORATORYCONFIDENTIALITYDEED_SYNC = "ACTION_LABORATORYCONFIDENTIALITYDEED_SYNC",
    ACTION_LABORATORYCONFIDENTIALITYDEED_SYNC_SUCCESS = "ACTION_LABORATORYCONFIDENTIALITYDEED_SYNC_SUCCESS",
    ACTION_LABORATORYCONFIDENTIALITYDEED_SYNC_FAILURE = "ACTION_LABORATORYCONFIDENTIALITYDEED_SYNC_FAILURE",

    ACTION_LABORATORYCONFIDENTIALITYDEED_CLEAR = "ACTION_LABORATORYCONFIDENTIALITYDEED_CLEAR",

    ACTION_LABORATORYCONFIDENTIALITYDEED_FILTER = "ACTION_LABORATORYCONFIDENTIALITYDEED_FILTER";

export interface ILaboratoryConfidentialityDeedLoadByLaboratoryIdAction {
    type: "ACTION_LABORATORYCONFIDENTIALITYDEED_LOAD_BY_LABORATORY_ID";
    laboratoryId: number;
}

export interface ILaboratoryConfidentialityDeedLoadByLaboratoryIdActionCreator {
    (laboratoryId: number): ILaboratoryConfidentialityDeedLoadByLaboratoryIdAction;
}

export interface ILaboratoryConfidentialityDeedLoadSuccessAction {
    type: "ACTION_LABORATORYCONFIDENTIALITYDEED_LOAD_SUCCESS";
    formData: Dtos.LaboratoryConfidentialityDeed | Dtos.LaboratoryConfidentialityDeed[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface ILaboratoryConfidentialityDeedLoadSuccessActionCreator {
    (
        formData: Dtos.LaboratoryConfidentialityDeed | Dtos.LaboratoryConfidentialityDeed[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): ILaboratoryConfidentialityDeedLoadSuccessAction;
}

export interface ILaboratoryConfidentialityDeedLoadFailureAction {
    type: "ACTION_LABORATORYCONFIDENTIALITYDEED_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface ILaboratoryConfidentialityDeedLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ILaboratoryConfidentialityDeedLoadFailureAction;
}

export interface ILaboratoryConfidentialityDeedLoadByIdAction {
    type: "ACTION_LABORATORYCONFIDENTIALITYDEED_LOAD_BY_ID";
    id: number;
}

export interface ILaboratoryConfidentialityDeedLoadByIdActionCreator {
    (id: number): ILaboratoryConfidentialityDeedLoadByIdAction;
}

export interface ILaboratoryConfidentialityDeedSaveAction {
    type: "ACTION_LABORATORYCONFIDENTIALITYDEED_SAVE";
    formData: Dtos.LaboratoryConfidentialityDeed;

}

export interface ILaboratoryConfidentialityDeedSaveActionCreator {
    (
        formData: Dtos.LaboratoryConfidentialityDeed
    ): ILaboratoryConfidentialityDeedSaveAction;
}

export interface ILaboratoryConfidentialityDeedSaveSuccessAction {
    type: "ACTION_LABORATORYCONFIDENTIALITYDEED_SAVE_SUCCESS";
    formData: Dtos.LaboratoryConfidentialityDeed;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ILaboratoryConfidentialityDeedSaveSuccessActionCreator {
    (
        formData: Dtos.LaboratoryConfidentialityDeed,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ILaboratoryConfidentialityDeedSaveSuccessAction;
}

export interface ILaboratoryConfidentialityDeedSaveFailureAction {
    type: "ACTION_LABORATORYCONFIDENTIALITYDEED_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ILaboratoryConfidentialityDeedSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ILaboratoryConfidentialityDeedSaveFailureAction;
}

export interface ILaboratoryConfidentialityDeedValidateAction {
    type: "ACTION_LABORATORYCONFIDENTIALITYDEED_VALIDATE";
    formData: Dtos.LaboratoryConfidentialityDeed;

}

export interface ILaboratoryConfidentialityDeedValidateActionCreator {
    (
        formData: Dtos.LaboratoryConfidentialityDeed
    ): ILaboratoryConfidentialityDeedValidateAction;
}

export interface ILaboratoryConfidentialityDeedValidateSuccessAction {
    type: "ACTION_LABORATORYCONFIDENTIALITYDEED_VALIDATE_SUCCESS";
    formData: Dtos.LaboratoryConfidentialityDeed;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ILaboratoryConfidentialityDeedValidateSuccessActionCreator {
    (
        formData: Dtos.LaboratoryConfidentialityDeed,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ILaboratoryConfidentialityDeedValidateSuccessAction;
}

export interface ILaboratoryConfidentialityDeedValidateFailureAction {
    type: "ACTION_LABORATORYCONFIDENTIALITYDEED_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ILaboratoryConfidentialityDeedValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ILaboratoryConfidentialityDeedValidateFailureAction;
}

export interface ILaboratoryConfidentialityDeedCreateAction {
    type: "ACTION_LABORATORYCONFIDENTIALITYDEED_CREATE",
    laboratoryId: number
}

export interface ILaboratoryConfidentialityDeedCreateActionCreator {
    (laboratoryId: number): ILaboratoryConfidentialityDeedCreateAction
}

export interface ILaboratoryConfidentialityDeedCreateSuccessAction {
    type: "ACTION_LABORATORYCONFIDENTIALITYDEED_CREATE_SUCCESS";
    formData: Dtos.LaboratoryConfidentialityDeed;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
}

export interface ILaboratoryConfidentialityDeedCreateSuccessActionCreator {
    (
        formData: Dtos.LaboratoryConfidentialityDeed,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): ILaboratoryConfidentialityDeedCreateSuccessAction;
}

export interface ILaboratoryConfidentialityDeedCreateFailureAction {
    type: "ACTION_LABORATORYCONFIDENTIALITYDEED_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ILaboratoryConfidentialityDeedCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ILaboratoryConfidentialityDeedCreateFailureAction;
}

export interface ILaboratoryConfidentialityDeedDeleteAction {
    type: "ACTION_LABORATORYCONFIDENTIALITYDEED_DELETE";
    id: number;
}

export interface ILaboratoryConfidentialityDeedDeleteActionCreator {
    (id: number): ILaboratoryConfidentialityDeedDeleteAction
}

export interface ILaboratoryConfidentialityDeedDeleteSuccessAction {
    type: "ACTION_LABORATORYCONFIDENTIALITYDEED_DELETE_SUCCESS";
}

export interface ILaboratoryConfidentialityDeedDeleteSuccessActionCreator {
    (): ILaboratoryConfidentialityDeedDeleteSuccessAction;
}

export interface ILaboratoryConfidentialityDeedDeleteFailureAction {
    type: "ACTION_LABORATORYCONFIDENTIALITYDEED_DELETE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ILaboratoryConfidentialityDeedDeleteFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ILaboratoryConfidentialityDeedDeleteFailureAction;
}

export interface ILaboratoryConfidentialityDeedClearAction {
    type: "ACTION_LABORATORYCONFIDENTIALITYDEED_CLEAR";
    propertiesToClear?: string[];
}

export interface ILaboratoryConfidentialityDeedClearActionCreator {
    (propertiesToClear?: string[]): ILaboratoryConfidentialityDeedClearAction;
}

export interface ILaboratoryConfidentialityDeedFilterActionCreator {
    (formFilter: IFormFilter): ILaboratoryConfidentialityDeedFilterAction;
}

export interface ILaboratoryConfidentialityDeedFilterAction {
    type: "ACTION_LABORATORYCONFIDENTIALITYDEED_FILTER";
    formFilter: IFormFilter;
}

export interface ILaboratoryConfidentialityDeedSyncAction {
    type: "ACTION_LABORATORYCONFIDENTIALITYDEED_SYNC",
    laboratoryId: number
}

export interface ILaboratoryConfidentialityDeedSyncActionCreator {
    (laboratoryId: number): ILaboratoryConfidentialityDeedSyncAction
}

export interface ILaboratoryConfidentialityDeedSyncSuccessAction {
    type: "ACTION_LABORATORYCONFIDENTIALITYDEED_SYNC_SUCCESS";
    formData: Dtos.LaboratoryConfidentialityDeed[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus
}

export interface ILaboratoryConfidentialityDeedSyncSuccessActionCreator {
    (
        formData: Dtos.LaboratoryConfidentialityDeed[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): ILaboratoryConfidentialityDeedSyncSuccessAction;
}

export interface ILaboratoryConfidentialityDeedSyncFailureAction {
    type: "ACTION_LABORATORYCONFIDENTIALITYDEED_SYNC_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ILaboratoryConfidentialityDeedSyncFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ILaboratoryConfidentialityDeedSyncFailureAction;
}

export type LaboratoryConfidentialityDeedAction =
    ILaboratoryConfidentialityDeedLoadByLaboratoryIdAction |
    ILaboratoryConfidentialityDeedLoadByIdAction |
    ILaboratoryConfidentialityDeedLoadFailureAction |
    ILaboratoryConfidentialityDeedLoadSuccessAction |
    ILaboratoryConfidentialityDeedSaveAction |
    ILaboratoryConfidentialityDeedSaveSuccessAction |
    ILaboratoryConfidentialityDeedSaveFailureAction |
    ILaboratoryConfidentialityDeedValidateAction |
    ILaboratoryConfidentialityDeedValidateSuccessAction |
    ILaboratoryConfidentialityDeedValidateFailureAction |
    ILaboratoryConfidentialityDeedCreateAction |
    ILaboratoryConfidentialityDeedCreateSuccessAction |
    ILaboratoryConfidentialityDeedCreateFailureAction |
    ILaboratoryConfidentialityDeedDeleteAction |
    ILaboratoryConfidentialityDeedDeleteSuccessAction |
    ILaboratoryConfidentialityDeedDeleteFailureAction |
    ILaboratoryConfidentialityDeedSyncAction |
    ILaboratoryConfidentialityDeedSyncSuccessAction |
    ILaboratoryConfidentialityDeedSyncFailureAction |
    ILaboratoryConfidentialityDeedClearAction | 
    ILaboratoryConfidentialityDeedFilterAction;
